angular.module('unergie.main').directive('salesTunnelQuotationV3', ($q, $rootScope, $window, $filter, $timeout, mapUtils, MetaWatcher, DraftsBasic, ApiUser, Tariff, ReferencesService, Landscape,
    EstimateTimetableService, ModalService, BoFeaturesService, ErrorCatcher, TimetableGeneration, AlertManager, ApiAdmin) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        prm: '=',
        landscape: '=',
        disableContractEdition: '=',
        providerCalendar: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelQuotationV3.html',
    link($scope) {
        const isEnvDev = BoFeaturesService.get('isEnvDev')
        $scope.canImportLandscape = BoFeaturesService.getModuleFeatures('contracts').canImportLandscape
        $scope.landscapeDefaultSource = BoFeaturesService.get('isEnvProd') ? '' : 'CTWMRURN6'
        $scope.showTimetableActions = BoFeaturesService.isFeatureOn('showTimetableActions')
        $scope.seniorAdvisor = BoFeaturesService.isFeatureOn('seniorAdvisor')
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.firstTrigger = true
        $scope.showTimetableGraph = false
        $scope.fetchingLandscapeRequirement = false
        $scope.cons = {}
        $scope.prm_last_update = null
        $scope.displayCarMessage = false
        $scope.displayAdjustments = false
        $scope.initialSleekedMonthlyPayments = null
        $scope.sleekedMonthlyPayments = null
        $scope.isWithoutPrm = () => !_.get($scope.prm, 'id_prm') && !_.get($scope.draft, 'draftElec.id_prm') && !!$scope.draft.bill_addr_post_code
        $scope.adjustments = [
            { label: '-15%', value: -15 },
            { label: '-10%', value: -10 },
            { label: '-5%', value: -5 },
            { label: '', value: 0 },
            { label: '5%', value: 5 },
            { label: '10%', value: 10 },
            { label: '15%', value: 15 },
        ]
        $scope.selectedAdjustment = { label: '', value: 0 }

        $scope.WITHOUT_PRM_ID_P_CALENDAR = 'BASE'
        $scope.WITHOUT_PRM_MAX_POWER = 6
        $scope.DOUBLED_POT_OFFERS = ['ECO_CONSO+'] // en attendant d'avoir la propriété portée par l'offre

        $scope.simulations = {
            simulationResult: {},
            refResult: {},
            simulationMinus10: {},
        }

        $scope.carForm = {
            HP: undefined,
            HC: undefined,
            BASE: undefined,
        }

        // FORM
        $scope.form = {}

        $scope.PREFERRED_ESTIMATOR_MAPPING = {
            AVERAGED_CONS: 'averaged',
            DECLARED_CONS: 'declared',
            CONS_MEASURE: 'measure',
            null: 'default',
        }

        $scope.billingModalityMapping = {
            '2month': 'bimestrielle',
            '12month': 'annuelle',
        }

        // REFS
        $scope.preferredDays = []
        ReferencesService.getRef('pref-payment-days').then((mapping) => {
            $scope.preferredDays = (_.range(mapping.MIN, mapping.MAX + 1).map((num) => num))
        })

        // VALIDATORS
        const initComponentValidator = () => {
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isLandscapeValid(store) {
                    return !!store.draft.bulk_purchase || (store.landscape.landscapeRequired === false) || (store.landscape.landscapeDone === true)
                },
                isPromoCodeValid(store) {
                    return _.isEmpty(store.prm.promoErrorMessage)
                },
                isPreferredPaymentDayValid(store) {
                    return $scope.preferredDays.indexOf(store.draft.preferred_payment_day) > -1
                },
                isBillingFrequencyDefined(store) {
                    return ['12month', '2month'].includes(store.draft.billing_modality)
                },
                isCarDefined(store) {
                    // if DECLARED_CONS then declared_cons needs to be filled (and !displayCarMessage) otherwise ok
                    return !!(($scope.draft.preferred_estimator !== 'DECLARED_CONS' || !_.isEmpty(store.draft.declared_cons)) && !$scope.displayCarMessage)
                },
            })
        }

        $scope.checkCarFormat = () => {
            if (!$scope.draft.draftElec.id_p_calendar && !$scope.draft.draftElec.choosen_id_p_calendar) return false
            const computedTempClass = $scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar
            const expectedTempClass = $scope.providerCalendar.find((item) => item.id === computedTempClass)
            const listExpectedTempClass = Object.keys(expectedTempClass.dial)
            const listDeclaredConsTempClass = Object.keys($scope.carForm)

            const undefinedValues = listExpectedTempClass.filter((tempClass) => !listDeclaredConsTempClass.includes(tempClass) || !$scope.carForm[tempClass])
            return undefinedValues.length === 0
        }

        $scope.saveLandscape = function (payload) {
            $scope.landscape = _.assign({}, $scope.landscape, payload)
            MetaWatcher.notif('SALES_TUNNEL.SAVE_LANDSCAPE', payload)
        }

        $scope.saveSubscriptionPrice = function (payload) {
            $scope.simulations = _.assign({}, {
                simulationResult: {},
                refResult: {},
                simulationMinus10: {},
            }, payload)
            MetaWatcher.notif('SALES_TUNNEL.SUBSCRIPTION_PRICE', $scope.simulations)
        }

        // CHECK LANDSCAPE & CHECK SIMULATE
        const checkLandscapeRequired = function () {
            $scope.fetchingLandscapeRequirement = true
            return DraftsBasic.checkLandscapeRequired({ id_draft_basic: $scope.draft.id }).$promise.finally(() => {
                $scope.fetchingLandscapeRequirement = false
            })
        }

        const readyToEstimate = function () {
            const isNotFetchingLandscapeRequirement = (!$scope.fetchingLandscapeRequirement)
            const isLandscapeValid = $scope.isRequiredLandscapeDone()
            const isResidenceAndHeatingOk = $scope.landscape.landscapeRequired === true
                || (($scope.draft.primary_residence != null || $scope.draft.account_category === 'small-business') && $scope.draft.heating != null)
            const isCarValid = $scope.draft.account_category === 'small-business' && $scope.draft.declared_cons && $scope.checkCarFormat($scope.carForm)
            const isMaxPowerDefined = !!($scope.draft.draftElec.max_power || $scope.draft.draftElec.choosen_max_power)
            const isIDPCalendarDefined = !!($scope.draft.draftElec.id_p_calendar || $scope.draft.draftElec.choosen_id_p_calendar)
            return $scope.isWithoutPrm() || (isNotFetchingLandscapeRequirement && (isLandscapeValid || isCarValid) && isMaxPowerDefined && isIDPCalendarDefined && isResidenceAndHeatingOk)
        }

        const getEstimatedForEstimator = (estimator) => {
            $scope.errorMessage = undefined
            $scope.estimating = true
            const payload = _.assign({ timePeriod: { endDate: '13-month-trunc' } },
                $scope.isWithoutPrm() ? { input: { citycode: $scope.draft.bill_addr_city_code, postcode: $scope.draft.bill_addr_post_code } } : {})
            return ApiUser.draftEstimatedV2({
                idContract: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id,
                estimator,
                withoutPrm: $scope.isWithoutPrm(),
            }, payload).$promise.then((rawEstimated) => {
                const estimated = rawEstimated.toJSON()
                const esti = estimator ||
                    ($scope.draft.bulk_purchase && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) ||
                    ($scope.draft.account_category === 'small-business' && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) ||
                    'default'
                $scope.cons[esti] = estimated
                return Math.round(_.sum(_.values($scope.cons[esti].annual)))
            })
            .catch((error) => {
                if (error && error.data && error.data && error.data.code) {
                    const idPCalendar = $scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar
                    const maxPower = $scope.draft.draftElec.choosen_max_power || $scope.draft.draftElec.max_power
                    $scope.displayCarMessage = true
                    if (error.data.code === 'CONS_TOO_HIGH') {
                        $scope.carErrorMessage = `La CAR du client semble être haute pour un client en ${idPCalendar}/${maxPower} kVa. Êtes vous sûr ?`
                    } else if (error.data.code === 'CONS_TOO_LOW') {
                        $scope.carErrorMessage = `La CAR du client semble être basse pour un client en ${idPCalendar}/${maxPower} kVa. Êtes vous sûr ?`
                    }
                } else {
                    ErrorCatcher(error)
                }
                $scope.saveSubscriptionPrice()
            })
            .finally(() => {
                $scope.estimating = false
            })
        }

        const fetchAnnualCons = function () {
            $scope.cons = {}
            $scope.saveSubscriptionPrice({})
            if ($scope.draft.bulk_purchase && !$scope.landscape.landscapeRequired) {
                return $q.all({
                    averaged: getEstimatedForEstimator('averaged'),
                    measure: getEstimatedForEstimator('measure'),
                    declared: getEstimatedForEstimator('declared'),
                }).then((estimators) => {
                    MetaWatcher.notif('SALES_TUNNEL.MODIFIED_ESTIMATED_CONS', estimators)
                })
            }
            return getEstimatedForEstimator()
        }

        $scope.onDraftUpdated = function (draftState, previousDraftState) {
            // check for modifications first
            if (!$scope.firstTrigger &&
                !Object.keys(_.omitBy(_.omit(draftState.draftElec, ['modification_ts', '$promise']), (elem, key) => _.isEqual(previousDraftState.draftElec[key], elem))).length &&
                !Object.keys(_.omitBy(_.omit(draftState, ['modification_ts', 'draftElec', '$promise']), (elem, key) => _.isEqual(previousDraftState[key], elem))).length) {
                // apart from firstTrigger do not perform if all data is the same
                return
            }
            $scope.firstTrigger = false

            const isDraftCalendarChanged = previousDraftState.declared_cons &&
                previousDraftState.declared_cons.calendar &&
                mapUtils.hasDifference(draftState, previousDraftState, ['declared_cons.calendar'])
            const isDraftFieldDefined = mapUtils.arePropsDefined(draftState, ['is_a_move', 'draftElec.id_prm']) && $scope.prm.eligible
            const isDraftFieldChanged = mapUtils.hasDifference(draftState, previousDraftState, ['is_a_move', 'draftElec.id_prm', 'heating', 'primary_residence'])
            const isOfferFieldChanged = mapUtils.hasDifference(draftState, previousDraftState, ['draftElec.max_power', 'draftElec.choosen_max_power', 'draftElec.id_p_calendar', 'draftElec.choosen_id_p_calendar'])
            const isPrmUpdated = $scope.prm.eligible && $scope.prm.last_update !== $scope.prm_last_update
            const isDeclaredConsUpdated = $scope.draft.declared_cons && mapUtils.hasDifference(draftState, previousDraftState, ['declared_cons.cons'])
            const isAccountCategoryUpdated = $scope.draft.account_category && mapUtils.hasDifference(draftState, previousDraftState, ['account_category'])
            $scope.prm_last_update = $scope.prm.last_update

            $scope.landscapeDraftStub = { id: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id }
            $scope.form = {
                sleek_timetable: _.get(draftState, 'sleek_timetable'),
                preferred_payment_day: _.get(draftState, 'preferred_payment_day'),
                billing_modality: _.get(draftState, 'billing_modality'),
            }

            if (isDraftCalendarChanged && !_.isEmpty($scope.carForm)) {
                $scope.carForm = {}
            }

            if ($scope.draft.declared_cons && isDeclaredConsUpdated && _.isEqual(draftState.draftElec.id_prm, previousDraftState.draftElec.id_prm)) {
                $scope.carForm = $scope.draft.declared_cons.cons
                $scope.estimate()
            }

            if (!_.isEqual(draftState.provider_offer, previousDraftState.provider_offer)) {
                $scope.estimate()
            }

            if (!_.isEqual(draftState.draftElec.id_prm, previousDraftState.draftElec.id_prm)) {
                $scope.saveDraft({
                    declared_cons: null,
                    preferred_estimator: null,
                })
                $scope.carForm = {}
            }

            // Check to execute landscape or reset data
            if ($scope.disableContractEdition && $scope.draft.providerOffer) {
                $scope.checkLandscape()
            } else if (isDraftFieldDefined || $scope.isWithoutPrm()) {
                if (isDraftFieldChanged || ($scope.landscape.landscapeRequired === null)) {
                    $scope.saveLandscape({ landscapeRequired: null })
                    $scope.saveSubscriptionPrice({})
                }
                if ($scope.canLandscape() && (isDraftFieldChanged || isOfferFieldChanged || isPrmUpdated || $scope.isWithoutPrm())) {
                    $scope.checkLandscape()
                }
            }
            else {
                $scope.saveLandscape({ landscapeRequired: null })
                $scope.saveSubscriptionPrice({})
            }

            $scope.computedIdPCalendar = $scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar
            if (isAccountCategoryUpdated) {
                initComponentValidator()
            }
        }

        $scope.$watch('draft', $scope.onDraftUpdated)

        $scope.checkLandscape = () => {
            // Be very careful of condition combinations to prevent infinite loops.
            // We trigger this method on draft update AND we update the draft inside this method...
            if ($scope.isWithoutPrm()) {
                if ($scope.landscape.landscapeDone) {
                    return $scope.estimate()
                }
                return
            }
            return checkLandscapeRequired().then((landscapeRequirement) => {
                const landscapeRequired = ($scope.draft.is_a_move || landscapeRequirement.required)
                $scope.saveLandscape({ landscapeRequired })
                if (landscapeRequired && ($scope.draft.bulk_purchase || $scope.draft.account_category === 'small-business') && $scope.draft.preferred_estimator !== 'DECLARED_CONS') {
                    $scope.saveDraft({ preferred_estimator: 'DECLARED_CONS' }, true)
                    .then(() => {
                        $scope.estimate()
                    })
                } else if (landscapeRequired === false && ($scope.draft.bulk_purchase || $scope.draft.preferred_estimator !== 'DECLARED_CONS')) {
                    if ($scope.disableContractEdition) {
                        $scope.estimate()
                    } else {
                        $scope.saveDraft({
                            declared_cons: null,
                            preferred_estimator: null,
                        }, true).then(() => {
                            $scope.estimate()
                        })
                    }
                } else if (landscapeRequired && $scope.landscape.landscapeDone) {
                    $scope.estimate()
                } else if (landscapeRequired && $scope.draft.primary_residence != null && $scope.draft.heating) {
                    MetaWatcher.notif('SALES_TUNNEL.DRAFT_INTEREST_SCORING_TRIGGER')
                }
            })
        }

        $scope.estimate = function () {
            // Execute only after landscape checked
            if (readyToEstimate()) {
                return fetchAnnualCons()
                .then((result) => {
                    $scope.fetching = false
                    if (result) {
                        return $scope.simulate()
                    }
                })
                .then(() => {
                    MetaWatcher.notif('SALES_TUNNEL.DRAFT_INTEREST_SCORING_TRIGGER')
                })
            }
            $scope.fetching = false
        }

        // LANDSCAPE
        $scope.canLandscape = function () {
            const isPrmEligible = $scope.prm.eligible
            const isMaxPowerDefined = !!($scope.draft.draftElec.max_power || $scope.draft.draftElec.choosen_max_power)
            const isIdPCalendarDefined = !!($scope.draft.draftElec.id_p_calendar || $scope.draft.draftElec.choosen_id_p_calendar)
            return $scope.isWithoutPrm() || (isPrmEligible && isMaxPowerDefined && isIdPCalendarDefined && !$scope.disableContractEdition)
        }

        const onLandscapeChanged = (result = {}) => {
            if (result.heating) {
                $scope.draft.heating = result.heating
            }
            if (_.isBoolean(result.primary_residence)) {
                $scope.draft.primary_residence = result.primary_residence
            }
            $scope.saveLandscape({ landscapeDone: !!result.landscapeDone, landscapeVersion: result.landscapeVersion })
            if ($scope.landscape.landscapeRequired || $scope.isWithoutPrm()) {
                $scope.estimate()
            }
        }

        $scope.onLandscapeImported = (result) => {
            onLandscapeChanged(_.assign({}, result, { landscapeDone: true, landscapeVersion: result.version }))
        }

        $scope.openLandscape = function (display = false, openNewLandscape = false) {
            if (openNewLandscape) {
                Landscape.openSimplifiedLandscapeModal($scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id).result.then(onLandscapeChanged)
            } else {
                Landscape.openLandscape($scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id, display).then(onLandscapeChanged)
            }
        }

        $scope.isRequiredLandscapeDone = () => {
            return $scope.landscape.landscapeRequired === false || $scope.landscape.landscapeDone === true || $scope.draft.bulk_purchase
        }

        // SIMULATION
        const generateSimulationsPayload = function () {
            // { tempClass1: [a, b, ...], tempClass2: [x, y, ...] }
            //  => [{ tempClass1: a, tempClass2: x }, { tempClass1: b, tempClass2: y }, ...]
            const monthly = Object.keys($scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].monthly).reduce((acc, tempClass) => {
                $scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].monthly[tempClass].forEach((cons, i) => {
                    if (!acc[i]) {
                        acc[i] = {}
                    }
                    acc[i][tempClass] = cons
                })

                return acc
            }, [])

            const simulation = {
                provider_offer: $scope.draft.provider_offer,
                addr_city_code: $scope.draft.addr_city_code,
                id_p_calendar: $scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar,
                max_power: $scope.draft.draftElec.choosen_max_power || $scope.draft.draftElec.max_power,
                id_ref_promo: $scope.draft.id_ref_promo,
                cons: {
                    monthly,
                    timePeriod: $scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].timePeriod,
                },
            }
            if ($scope.isWithoutPrm()) {
                _.assign(simulation, {
                    addr_city_code: $scope.draft.bill_addr_city_code,
                    id_p_calendar: $scope.WITHOUT_PRM_ID_P_CALENDAR,
                    max_power: $scope.WITHOUT_PRM_MAX_POWER,
                })
            }
            return {
                simulationResult: Tariff.simulationV2(simulation).$promise,
                refResult: Tariff.simulationV2(_.assign({}, simulation, { provider_offer: 'TRV_REF' })).$promise,
                simulationMinus10: $scope.draft.providerOffer.has_pot && Tariff.simulationV2(_.assign({}, simulation, { reduction: -10 })).$promise,
            }
        }

        $scope.simulate = function () {
            $scope.saveSubscriptionPrice({})
            $scope.simulating = true
            return $q.all(generateSimulationsPayload()).then((data) => $scope.saveSubscriptionPrice(data))
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.simulating = false
            })
        }

        $scope.toggleShowTimetableGraph = () => {
            $scope.showTimetableGraph = !$scope.showTimetableGraph
        }

        // ESTIMATED TIMETABLE
        $scope.estimateTimetable = function () {
            $scope.fetchingEstimTt = true
            EstimateTimetableService.openModal({ id: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id }, (result) => {
                $scope.fetchingEstimTt = false
            })
        }

        // TIMELINE
        $scope.timeline = { default: [] }

        // TIMETABLE DATA TRANSFORMATION
        // Quotation second reading date locally => first reading date + 6 month
        // The idea is to hide price after second reading date
        const fetchSecondReadingDate = function (values) {
            const item = _.find(values, 'nextReading')
            return item ? moment({ year: item.year, month: item.month - 1 }).add(6, 'month') : moment.invalid()
        }

        const mapTimetableItemToGraphData = (draft, secondReadingDate) => function (item, index) {
            const momentDate = moment({ year: item.year, month: item.month - 1 })
            const amount = Math.floor(item.total * 100) / 100
            const yearly = Math.floor(item.yearly * 100) / 100
            const sleeked = Math.floor(item.sleeked * 100) / 100
            if (index === 1) {
                $scope.initialSleekedMonthlyPayments = sleeked
                $scope.selectedAdjustment = { label: '', value: 0 }
                if ($scope.draft.draftElec.estimated_amendment) {
                    const { priceModifPercentage } = $scope.draft.draftElec.estimated_amendment
                    $scope.initialSleekedMonthlyPayments = (sleeked * 100) / (100 + priceModifPercentage)
                    $scope.selectedAdjustment = { label: `${priceModifPercentage}%`, value: priceModifPercentage }
                }
                $scope.sleekedMonthlyPayments = Math.round(sleeked)
            }
            return {
                date: momentDate.format('YYYY-MM-DD'),
                billingDate: momentDate.format('MMMM YYYY').toLowerCase(),
                amount,
                yearly,
                sleeked,
                toDisplaySleeked: sleeked,
                toDisplayUnsleeked: yearly,
                nextReading: _.get(item, 'nextReading', false) || secondReadingDate.isSame(momentDate, 'month'),
                amountDisplay: !secondReadingDate.isValid() || momentDate.isBefore(secondReadingDate, 'month'),
            }
        }

        const timelineToGraphData = (draft, values) => _.map(values, mapTimetableItemToGraphData(draft, fetchSecondReadingDate(values))).slice(0, 12)

        const getTimelineForEstimator = (estimator) => {
            const payload = $scope.isWithoutPrm() ? { input: { citycode: $scope.draft.bill_addr_city_code, postcode: $scope.draft.bill_addr_post_code } } : {}
            return TimetableGeneration.draftTimetableV2({
                idContract: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id,
                estimator,
                withoutPrm: $scope.isWithoutPrm(),
            }, payload)
            .$promise.then((data) => {
                if (_.isEmpty(data)) {
                    AlertManager.error('Il n’y a pas d’échéancier pour le contrat')
                } else {
                    const esti = estimator ||
                        ($scope.draft.bulk_purchase && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) ||
                        ($scope.draft.account_category === 'small-business' && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) ||
                        'default'
                    $scope.timeline[esti] = timelineToGraphData($scope.draft, data)
                    return $scope.timeline[esti][1].yearly.toFixed(2)
                }
            }).catch((error) => {
                ErrorCatcher(error)
                throw error
            })
        }

        const loadGraphData = () => {
            $scope.showTimetableGraph = !$scope.draft.sleek_timetable

            if ($scope.draft.bulk_purchase && !$scope.landscape.landscapeRequired) {
                $q.all({
                    averaged: getTimelineForEstimator('averaged'),
                    declared: getTimelineForEstimator('declared'),
                    measure: getTimelineForEstimator('measure'),
                }).then((estimators) => {
                    MetaWatcher.notif('SALES_TUNNEL.MODIFIED_ESTIMATED_EUROS', estimators)
                })
            } else {
                getTimelineForEstimator()
            }
        }

        if ($scope.seniorAdvisor) {
            ApiUser.getLastWithoutPrmEstimation({ id_draft_basic: $scope.draft.id }).$promise.then((result) => {
                $scope.lastWithoutPrmEstimation = result
            })
            .catch(ErrorCatcher)
        }

        MetaWatcher.watch('SALES_TUNNEL.MODIFIED_BILLING_MODALITY', 'salesTunnelQuotation', $scope, loadGraphData)
        MetaWatcher.watch('SALES_TUNNEL.RELOAD_ESTIMATION', 'salesTunnelQuotation', $scope, $scope.estimate)

        $scope.$watch('simulations.simulationResult', (simulationResult) => {
            if (_.isEmpty(simulationResult)) {
                $scope.timeline = { default: [] }
            } else {
                loadGraphData()
            }
        })

        $scope.disableCarEvaluation = () => {
            return $scope.checkCarFormat($scope.carForm)
        }

        $scope.saveCar = (force) => {
            $scope.hideCarErrorMessage()
            const endDate = (isEnvDev) ? '2017-01-01' : moment().format('YYYY-MM-DD')
            $scope.saveDraft({ declared_cons: {
                timePeriod: {
                    startDate: moment(endDate).add(-1, 'year').format('YYYY-MM-DD'),
                    endDate,
                },
                calendar: $scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar,
                cons: $scope.carForm,
                force,
            } })
        }

        $scope.hideCarErrorMessage = () => {
            $scope.displayCarMessage = false
        }

        $scope.openWithOutPrmEstimation = () => {
            ModalService.openModal({ type: 'states/salesTunnelV3/modal/withoutPrmEstimationModal', size: 'md' }, { lastWithoutPrmEstimation: $scope.lastWithoutPrmEstimation })
        }

        $scope.selectAdjustment = (option) => {
            $scope.selectedAdjustment = option
            $scope.sleekedMonthlyPayments = Math.round($scope.initialSleekedMonthlyPayments)
            if (option.value !== 0) {
                const adjustedMonthlyPayments = $scope.initialSleekedMonthlyPayments * ((option.value + 100) / 100)
                $scope.sleekedMonthlyPayments = Math.round(adjustedMonthlyPayments)
            }
        }

        $scope.hasAdjustedMonthlyPayments = () => {
            return $scope.draft.draftElec.estimated_amendment
        }

        $scope.toggleAdjustments = () => {
            $scope.displayAdjustments = !$scope.displayAdjustments
        }

        $scope.openAdjustMonthlyPaymentsModal = () => {
            return ModalService.openModal(
                { type: 'states/salesTunnelV3/modal/adjustMonthlyPaymentsModal', size: 'lg' },
                { selectedAdjustment: $scope.selectedAdjustment, idDraftBasic: $scope.draft.id })
            .then(() => $scope.estimate())
        }

        $scope.getEstimationMailTo = () => {
            // bullet char %E2%80%A2 (https://unicode-table.com/en/2022/)
            const kwh = _.sum(_.values($scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].annual)).toFixed(0)
            const calendar = ($scope.draft.draftElec.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar) === 'BASE' ? 'Base' : 'Heures Pleines Heures Creuses'
            const price = $filter('frAmount')(
                $scope.timeline[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]][1][$scope.draft.sleek_timetable ? 'toDisplaySleeked' : 'toDisplayUnsleeked'].toFixed(2))
            return Promise.resolve()
            .then(() => {
                if (!$scope.draft.id.startsWith('VD')) {
                    return DraftsBasic.getDraftBasicRedirectUrl({ id_draft_basic: $scope.draft.id, mini: true }).$promise
                }
                return {}
            })
            .then(({ redirectUrl }) => {
                const mailto = `mailto:${$scope.draft.mail || ''}?subject=Suite à notre discussion sur Plüm énergie`
                + `&body=Chère cliente, cher client,%0A%0AJe fais suite à votre appel pour vous rappeler les informations sur`
                + ` notre partenariat avec le fournisseur d'électricité Plüm énergie et notre offre réservée aux clients de La Banque Postale.%0A%0A`
                + `Pourquoi La Banque Postale vous recommande Plüm énergie :%0A`
                + `    %E2%80%A2 C'est un fournisseur d'électricité 100%25 verte et française%0A`
                + `    %E2%80%A2 Leur service client est basé en France%0A`
                + `    %E2%80%A2 Pour vous aider à consommer moins, Plüm énergie vous verse des bonus en euros sur une cagnotte, chaque fois que votre consommation baisse%0A`
                + `%0ALes avantages réservés aux clients de La Banque Postale :%0ANous doublons `
                + `automatiquement les bonus éco-conso versés sur votre cagnotte.%0A%0A`
                + `L'estimation de vos mensualités :%0A`
                + `Pour une consommation estimée à ${kwh} kilowattheures par an et un `
                + `contrat au tarif ${calendar}, vos mensualités sont estimées à ${price} %E2%82%AC TTC %2F mois*.`
                + `${redirectUrl ? `%0A%0APour finaliser votre souscription, retrouvez ici le devis que nous avons initié ensemble :%0A${redirectUrl}` : ``}`
                + `%0A%0ASi vous le souhaitez, je suis joignable par téléphone ou email pour vous aider à finaliser la souscription.%0A%0ACordialement,%0A%0A`
                + `* Estimation dans le cadre du partenariat avec Plüm énergie et n'engage pas la responsabilité de la Banque Postale.%0A%0A%0A`

                $window.open(mailto, '_self')
            })
        }

        $scope.canSendQuotationMail = () => {
            return !$scope.sendingQuotationEmail && !$scope.simulating && !$scope.estimating
        }

        $scope.sendQuotationMail = () => {
            const kwh = _.sum(_.values($scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].annual)).toFixed(0)
            const calendar = $scope.isWithoutPrm || _.values(_.pick($scope.draft.draftElec, ['choosen_id_p_calendar', 'id_p_calendar'])).includes('BASE') ? 'Base' : 'Heures Pleines Heures Creuses'
            const price = $filter('frAmount')(
                $scope.timeline[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]][1][$scope.draft.sleek_timetable ? 'toDisplaySleeked' : 'toDisplayUnsleeked'].toFixed(2))
            const payload = {
                kwh,
                calendar,
                price,
            }
            $scope.sendingQuotationEmail = true
            return ApiAdmin.sendQuotationEmail({ id_draft_basic: $scope.draft.id }, payload).$promise
            .then(() => AlertManager.success('Email envoyé'))
            .catch((error) => {
                const errorClone = _.clone(error)
                if (_.get(errorClone, 'data.error.message') === `'to' is required`) {
                    errorClone.data.error.message = 'Renseigner une adresse mail'
                }
                ErrorCatcher(errorClone)
            })
            .finally(() => {
                $scope.sendingQuotationEmail = false
            })
        }

        const activate = () => {
            initComponentValidator()
        }

        return activate()
    },
}))
